var React = require('react');

function Backspace (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 6H9L3 12L9 18H21V6Z","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12 10L16 14M16 10L12 14","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Backspace.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Backspace;

Backspace.default = Backspace;
